import { render, staticRenderFns } from "./modalEnviarAprobacion.vue?vue&type=template&id=06ebb14d&"
import script from "./modalEnviarAprobacion.vue?vue&type=script&lang=js&"
export * from "./modalEnviarAprobacion.vue?vue&type=script&lang=js&"
import style0 from "./modalEnviarAprobacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ebb14d')) {
      api.createRecord('06ebb14d', component.options)
    } else {
      api.reload('06ebb14d', component.options)
    }
    module.hot.accept("./modalEnviarAprobacion.vue?vue&type=template&id=06ebb14d&", function () {
      api.rerender('06ebb14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalEnviarAprobacion.vue"
export default component.exports